import { render, staticRenderFns } from "./AddOrEditTechnologyModal.vue?vue&type=template&id=d51dcc12&scoped=true&"
import script from "./AddOrEditTechnologyModal.vue?vue&type=script&lang=ts&"
export * from "./AddOrEditTechnologyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51dcc12",
  null
  
)

export default component.exports